import { Record, OrderedMap } from 'immutable'

let siteStructure = {
  name: null,
  key: null,
  url: null,
  mode: null,
  auth: { user: null, pass: null },
  sitemaps: null,
  account: null,
  apiKeys: new OrderedMap(),
};
export default class extends new Record(siteStructure) {

  constructor(obj) {
    const newObj = { ...obj, apiKeys: !(obj.apiKeys instanceof OrderedMap) ? new OrderedMap(obj.apiKeys) : obj.apiKeys};
    super(newObj);
  }
}



// WEBPACK FOOTER //
// ./src/modules/sites/site.js